// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__kZvme","title":"Contact_title__0wKwV"};